document.addEventListener('DOMContentLoaded', () => {
  initGiftBoxPdp();
});

document.addEventListener('shopify:section:load', () => {
  initGiftBoxPdp();
});

function initGiftBoxPdp() {
  const forms = [
    ...document.querySelectorAll('product-form-component form[data-type="add-to-cart-form"]'),
    ...document.querySelectorAll('form[data-type="add-to-cart-form"]')
  ];

  if (!forms.length) return;

  async function refreshCartDrawerAndOpen() {
    if (typeof window.refreshCartDrawer === 'function') {
      await window.refreshCartDrawer();
    }
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.querySelector('button[on\\:click="/open"]')?.click();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function addOne(item) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('add_failed');
    return res.json();
  }

  function getQty(form) {
    // 1) Твой основной кейс: dropdown quantity
    let el =
      form.querySelector('select[name="quantity"]') ||
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('input[type="number"]');

    let qty = parseInt(el?.value || '1', 10);
    if (Number.isFinite(qty) && qty > 0) return qty;

    // 2) Фолбэк через FormData
    try {
      const fd = new FormData(form);
      qty = parseInt(fd.get('quantity') || '1', 10);
      if (Number.isFinite(qty) && qty > 0) return qty;
    } catch (_) {}

    return 1;
  }

  forms.forEach((form) => {
    // ВАЖНО: только формы, где есть upsell блок
    const upsell = form.querySelector('.giftbox-upsell');
    if (!upsell) return;

    if (form.dataset.giftboxInit === '1') return;
    form.dataset.giftboxInit = '1';

    const addBtn = form.querySelector('button[type="submit"], [type="submit"][name="add"], button[name="add"]');
    if (!addBtn) return;

    // Клонируем submit → button, чтобы тема не отправляла стандартный add и не было дублей
    const myBtn = addBtn.cloneNode(true);
    myBtn.type = 'button';
    myBtn.dataset.giftboxProxy = '1';
    addBtn.replaceWith(myBtn);

    const msgEl = upsell.querySelector('textarea[name="attributes[greeting_message]"]') || null;

    myBtn.addEventListener('click', async () => {
      if (myBtn.disabled) return;
      myBtn.disabled = true;

      try {
        const fd = new FormData(form);
        const mainVariantId = fd.get('id');
        if (!mainVariantId) throw new Error('missing_variant_id');

        const qty = getQty(form);

        let chosen = 'none';
        const r = upsell.querySelector('input[name="giftbox_option"]:checked');
        if (r) chosen = r.value;

        const message = msgEl?.value?.trim() || '';
        const giftGroup = String(Date.now());

        // 1) Добавляем вино/товар
        await addOne({
          id: mainVariantId,
          quantity: qty,
          properties: { _gift_group: giftGroup }
        });

        // 2) Добавляем коробку (если выбрана)
        if (chosen === '1' || chosen === '3') {
          const vId = chosen === '1' ? upsell.dataset.giftbox1Id : upsell.dataset.giftbox3Id;
          if (vId) {
            await addOne({
              id: Number(vId),
              quantity: 1,
              properties: {
                _gift_box: true,
                _capacity: Number(chosen),
                _gift_group: giftGroup,
                _gifted: '[]',
                _gift_contents: ''
              }
            });
          }
        }

        // 3) Сохраняем поздравление в атрибут корзины
        if (message) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ attributes: { greeting_message: message } })
          });
        }

        // 4) Обновляем и открываем drawer
        await refreshCartDrawerAndOpen();
      } catch (e) {
        console.error('[gift-box] add failed', e);
        alert('Artikel konnte nicht in den Warenkorb gelegt werden.');
      } finally {
        myBtn.disabled = false;
      }
    });
  });
}